export enum COPYRIGHT {
    MX = 'Extendeal MX SA de CV',
    AR = 'Extendeal S.A',
    CO = 'Extendeal Colombia SAS ',
}
